import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

import { getToken } from './auth';
import { getSubdomain } from '../helpers/domain';

window.Pusher = Pusher;

const authEndpoint = `${process.env.REACT_APP_URL.replace(/\/api\/admin\/?$/, '')}/broadcasting/auth`;

let echoInstance = null;

export const getEcho = () => {
    if (echoInstance) {
        return echoInstance;
    }

    if (!process.env.REACT_APP_REVERB_APP_KEY) {
        console.error('Echo/Reverb não configurado (REACT_APP_REVERB_APP_KEY ausente) — atualizações em tempo real desativadas.');
        return null;
    }

    try {
        echoInstance = new Echo({
            broadcaster: 'reverb',
            key: process.env.REACT_APP_REVERB_APP_KEY,
            wsHost: process.env.REACT_APP_REVERB_HOST,
            wsPort: process.env.REACT_APP_REVERB_PORT,
            wssPort: process.env.REACT_APP_REVERB_PORT,
            forceTLS: process.env.REACT_APP_REVERB_SCHEME === 'https',
            enabledTransports: ['ws', 'wss'],
            authEndpoint,
            auth: {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    subdomain: getSubdomain(),
                },
            },
        });
    } catch (error) {
        console.error('Falha ao iniciar Echo/Reverb — atualizações em tempo real desativadas.', error);
        echoInstance = null;
    }

    return echoInstance;
};

export const disconnectEcho = () => {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
};
